var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Icon } from '@material-ui/core';
import * as jwt from 'jsonwebtoken';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1(props) {
        var _this = _super.call(this, props) || this;
        _this.onClose = function () {
            _this.setState({ email: '', password: '', url: '' });
            _this.props.onClose();
        };
        _this.onCopy = function () {
            var copyText = document.querySelector('#copy-url');
            copyText.select();
            document.execCommand('copy');
            copyText.blur();
            _this.onClose();
        };
        _this.onCreate = function () {
            var orgId = _this.props.orgId;
            var token = jwt.sign({ email: _this.state.email, password: _this.state.password, redirect: window.location.pathname }, orgId);
            _this.setState({ url: window.location.origin + "/auto-login?token=" + token });
        };
        _this.state = {
            email: '',
            password: '',
            url: '',
        };
        return _this;
    }
    default_1.prototype.render = function () {
        var _this = this;
        var _a = this.props, open = _a.open, translate = _a.translate;
        return (React.createElement(Dialog, { open: open, onClose: this.onClose, fullWidth: true, maxWidth: "sm" },
            React.createElement(DialogTitle, null, translate('create-link')),
            React.createElement(DialogContent, { className: "flex flex-col" },
                React.createElement(TextField, { id: "create-link-email", label: translate('email'), value: this.state.email, onChange: function (e) { return _this.setState({ email: e.target.value }); } }),
                React.createElement(TextField, { className: "mt-16", id: "create-link-password", label: translate('password'), value: this.state.password, onChange: function (e) { return _this.setState({ password: e.target.value }); } }),
                this.state.url && (React.createElement("div", { className: "flex mt-32 items-center" },
                    React.createElement("input", { id: "copy-url", style: {
                            width: '100%',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }, value: this.state.url, onChange: function () { } }),
                    React.createElement(Icon, { className: "ml-16", style: { fontSize: 30, cursor: 'pointer' }, onClick: this.onCopy }, "file_copy")))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { name: "Cancel", id: "create-link-close-btn", onClick: function () { return _this.onClose(); } }, translate('cancel')),
                React.createElement(Button, { name: "Create", color: "primary", id: "create-link-button", disabled: !this.state.email || !this.state.password, onClick: this.onCreate }, translate('create')))));
    };
    return default_1;
}(React.Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/Main/CreateLinkDialog.tsx
// module id = 2040
// module chunks = 81